<div
  id="editorModeButtons"
  class="splitToolbarButton toggled hiddenTinyView"
  role="radiogroup"
  *ngIf="!!showHighlightEditor || !!showStampEditor || !!showDrawEditor || !!showTextEditor"
>
  <pdf-highlight-editor [show]="showHighlightEditor"></pdf-highlight-editor>
  <pdf-text-editor [show]="showTextEditor"></pdf-text-editor>
  <pdf-stamp-editor [show]="showStampEditor"></pdf-stamp-editor>
  <pdf-draw-editor [show]="showDrawEditor"></pdf-draw-editor>
</div>

<div id="editorModeSeparator" class="verticalToolbarSeparator hiddenTinyView" *ngIf="!!showStampEditor || !!showDrawEditor || !!showTextEditor"></div>
